import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MasterSignalService } from 'src/app/shared/service/disbursment/master.signal.service';
import { tabs } from '../dis-repository/master.utils';

@Component({
  selector: 'app-master-tabs',
  templateUrl: './master-tabs.component.html',
  styleUrls: ['./master-tabs.component.scss']
})
export class MasterTabsComponent {
 selectedTabIndex = sessionStorage.getItem("masterTabIndex") || 0;

  constructor(private router: Router, private route: ActivatedRoute, private mastersignal: MasterSignalService) {
    this.externalTabClick();
  }

  roleId = Number(sessionStorage.getItem('roleId'));

  tabs: any[] = this.roleId === 1 ? tabs : tabs.filter(tab => tab.title != "User Management");

  // Method to route to the selected tab
  onTabChange = (index: number) => {
    console.log("roleId", Number(this.roleId) === 1);
    this.selectedTabIndex = index;
    const selectedRoute = tabs[index].route;
    sessionStorage.setItem("masterTabIndex", String(index));
    sessionStorage.setItem("masterTab", tabs[index].title);
    this.router.navigate([selectedRoute]);
  }

  externalTabClick = () => {
    const indexOfTab = tabs.findIndex(item => item.title == sessionStorage.getItem("masterTab"))
    this.onTabChange(indexOfTab)
  }
}
